import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import {  isNullOrUndefined, isValidString } from '@pineapplelab/util';
import { Observable } from 'rxjs';
import { AuthService } from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isSigned(route.data);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isSigned(route.data);
  }

  async isSigned(routeData: any) {
    const logged = await this.authService.isSigned();
    const redirectIfNotLogged = isValidString(routeData?.redirectIfNotLogged) ? routeData?.redirectIfNotLogged : '/auth/login';
    if (!logged) {
      this.authService.urlAfterLogin = location.pathname + location.search;
      this.router.navigateByUrl(redirectIfNotLogged);
      return false;
    }
    // Client-portal users have no staff permissions/employee doc — the root '' route loads the
    // staff dashboard shell (ProjectComponent), which throws/hangs for them (e.g. dereferencing
    // a null `auth.user`). Send them to their own portal instead of ever rendering that shell.
    if (this.authService.auth.isClientUser === true) {
      this.router.navigateByUrl('/client-portal');
      return false;
    }
    return true;
  }
}
